import {Box} from "@material-ui/core";
import React from "react";

const calendarDayNumberCell = (cellInfo:any) => {
    //console.log('calendarDayCell:',cellInfo);
    return <Box>{cellInfo.dayNumberText}</Box>;
}

export default calendarDayNumberCell;